import { shallow } from 'zustand/shallow';
import { createWithEqualityFn } from 'zustand/traditional';

interface ContactDrawerStore {
  activeDrawerContact: string | undefined;

  setActiveDrawerContact: (contact: string | undefined) => void;
}

const useContactDrawerStore = createWithEqualityFn<ContactDrawerStore>(
  (set) => ({
    activeDrawerContact: undefined,

    setActiveDrawerContact(contact: string | undefined) {
      set(() => ({ activeDrawerContact: contact }));
    },
  }),
  shallow
);

export default useContactDrawerStore;
